import React from "react";
import "./css/HelpCentre.css";

interface FAQ {
    question: string;
    answer: string;
}

const faqs: FAQ[] = [
    {
        question: "What is Skitterbook?",
        answer:
            "Skitterbook is a creative tool for turning short video clips into flipbook‑style animations with predictable, print‑ready output."
    },
    {
        question: "How do I upload a video?",
        answer:
            "Use the upload panel on the main workspace. Skitterbook accepts common video formats and extracts frames automatically."
    },
    {
        question: "Why do some frames look low‑resolution?",
        answer:
            "If the source video is low‑resolution or heavily compressed, the extracted frames will reflect that. Skitterbook preserves aspect ratio and avoids artificial upscaling."
    },
    {
        question: "Can I reorder or remove frames?",
        answer:
            "Yes. The frame grid allows selective removal and reordering, and updates the preview immediately."
    },
    {
        question: "How do I prepare my flipbook for printing?",
        answer:
            "Use the Print Readiness panel to view margins, layout guidance, and a preview of the final printed sheet."
    },
    {
        question: "Does Skitterbook store my videos?",
        answer:
            "No. All processing happens locally in your browser. Nothing is uploaded or stored externally."
    }
];

export const HelpCentre: React.FC = () => {
    return (
        <div className="help-centre">
            <p className="help-contact">
                If your question isn’t answered below, you can contact the site owner at{" "}
                <a
                    href="mailto:farauthoring.gmail.com?subject=Help%20with%20Skitterbook"
                    className="help-email"
                >
                    farauthoring.gmail.com
                </a>
                .
            </p>

            <table className="help-table">
                <thead>
                    <tr>
                        <th className="help-th">Question</th>
                        <th className="help-th">Answer</th>
                    </tr>
                </thead>
                <tbody>
                    {faqs.map((faq, index) => (
                        <tr key={index} className="help-row">
                            <td className="help-question">{faq.question}</td>
                            <td className="help-answer">{faq.answer}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default HelpCentre;
